export default __webpack_public_path__ + "static/media/centro_arcos.2dd59519.jpg";